import { DEFAULT_FREE_TRIAL_DAYS } from '@/common/constants';
import { mapGetters } from 'vuex';
import { plansof } from '@/utils/chain';
import { isEmptyVal } from '@/utils';
import { flowTypes, pageConfig } from '@/common/service/page-config';

export default {
  data() {
    return {
      trialDays: DEFAULT_FREE_TRIAL_DAYS,
      showPlanDetail: true,
      title: this.$t('billing.trial.title', [this.$t('billing.scheduler.title')]),
      trackingPlanName: this.$t('billing.trial.title', [this.$t('billing.scheduler.title')]),
      paidPurchaseLink: '',
      specialTrackingFlowTypes: 'Direct Purchase, pricing new add-ons, billing new add-ons'
    };
  },
  computed: {
    ...mapGetters(['getSelectedPlans', 'planMapFlat', 'getUserCurrentSubscriptions']),
    planList() {
      return plansof(this.planMapFlat).type(this.planType).get();
    },
    selectedPlan() {
      return plansof(this.getSelectedPlans).type(this.planType).get(0);
    }
  },
  created() {
    const selectedPlan = this.selectedPlan;
    if (!isEmptyVal(selectedPlan)) {
      this.trialDays = selectedPlan?.trialDays ?? this.trialDays;
      this.form.billingCycle = selectedPlan.billing_cycle;
      this.form.selectedNumber = selectedPlan.cartInfo?.selected_number;
      this.paidPurchaseLink = `/opc/buy?plan=zsched&period=${this.form.billingCycle}&from=zsched&originalFlowType=${flowTypes.buyTrial}`;
    }
  },
  methods: {
    // sync shopping cart plan to local form state
    updateForm(isInitUpdateForm = false) {
      // BUY TRIAL - quantity can't be changed, usually is only 1
      const { quantity = 1 } = pageConfig || {};
      const shoppingCartPlan = this.getSelectedPlans.find((item) => item.type === this.planType);
      if (shoppingCartPlan) {
        this.form.category = shoppingCartPlan.category;
        this.form.billingCycle = shoppingCartPlan.billing_cycle;
        this.form.selectedNumber = quantity;
        this.oldPlanCode = shoppingCartPlan.plan_code;
        this.trialDays = shoppingCartPlan.trialDays ?? this.trialDays;
        this.paidPurchaseLink = `/opc/buy?plan=zsched&period=${this.form.billingCycle}&from=zsched&originalFlowType=${flowTypes.buyTrial}`;
      }

      this.isInitUpdateForm = isInitUpdateForm;
      this.afterSwitchCycleTracking();
    },
    clickBuyNow(event) {
      if((event?.target?.tagName || '').toLowerCase() === 'a') {
        this.$tracking.addOnBuyInteraction(`product details`, `zoom scheduler free trial - need zoom scheduler for more than one user? - buy now`, `Direct Purchase, pricing new add-ons, billing new add-ons`);
      }
    },
    afterSwitchCycleTracking() {
      // event tracking
      const billingCycle = this.selectedPlan?.billing_cycle;
      billingCycle &&
        this.$tracking.buyInteraction(
          `${this.trackingPlanName} plan`,
          this.$t(`billing.billing_cycle.${billingCycle}`)?.toLowerCase(),
        );
    },
  },
};
